<template>
  <div 
    class="fts-widget-chart-design" 
    :data-widget-chart-design-load="loading ? 'loading' : 'loaded'"
  >
    <fts-spinner v-if="loading"/>

    <template v-else>
      <div class="d-widget-design-row" v-if="formData.source != 'listView'">
        <div class="d-widget-design-row-text">Show</div>
        <!-- module -->
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'moduleId',
            label: false,
          }"
          :validator="$v.formData"
          comfort-design
          key="moduleId"
        >
          <fts-select
            slot="formElement"
            slot-scope="{ formData, item, onInput, onBlur, error }"
            v-model="formData[item.fieldName]"
            :options="modules"
            placeholder="Module"
            :error="!!error"
            comfort-design
            popper-prevent-overflow-alt-axis
            @input="onInput();updateModuleId();"
            @search:blur="onBlur"
          >
            <fts-label-group
              slot="selected-option-container"
              slot-scope="{ option }"
              :item-id="option.id"
              :list="modules"
              emoji
            />
            <fts-label-group
              slot="option"
              slot-scope="{ option }"
              :item-id="option.id"
              :list="modules"
              emoji
            />
          </fts-select>
        </fts-form-element>
      </div>

      <div
        class="d-widget-design-row"
        v-if="
          formData.source != 'listView' && 
          Boolean(logicOptions && logicOptions.length) &&
          formData.moduleId &&
          formData.type !== 'content' &&
          beta
        "
      >
        <div class="d-widget-design-row-text">
          Logic
          <fts-release-badge class="fts-align-top" />
        </div>
        <!-- logic -->
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'logicId',
            displayName: 'Logic',
            label: false,
          }"
          :validator="$v.formData"
          comfort-design
          key="logicId"
        >
          <fts-select
            slot="formElement"
            slot-scope="{ formData, item, onInput, onBlur, error }"
            v-model="formData[item.fieldName]"
            :options="logicOptions"
            placeholder="Utilizing logic for data (optional)"
            :error="!!error"
            comfort-design
            popper-prevent-overflow-alt-axis
            @input="onInput"
            @search:blur="onBlur"
          >
            <fts-label-group
              slot="selected-option-container"
              slot-scope="{ option }"
              :item-id="option.id"
              :list="logicOptions"
              emoji
            />
            <fts-label-group
              slot="option"
              slot-scope="{ option }"
              :item-id="option.id"
              :list="logicOptions"
              emoji
            />
          </fts-select>
        </fts-form-element>
      </div>

      <template v-if="formData.moduleId">
        <div class="d-widget-design-row">
          <div class="d-widget-design-row-text">Do</div>
          <div class="fts-col-4">
            <!-- aggregate -->
            <fts-form-element
              :form-data="formData"
              :item="{
                fieldName: 'aggregate',
                label: false,
              }"
              :validator="$v.formData"
              comfort-design
              key="aggregate"
            >
              <fts-select
                slot="formElement"
                slot-scope="{ formData, item, onInput, onBlur, error }"
                v-model="formData[item.fieldName]"
                :options="aggregateOptions"
                placeholder="Aggregate"
                :error="!!error"
                comfort-design
                popper-prevent-overflow-alt-axis
                @input="onInput();updateAggregate()"
                @search:blur="onBlur"
              >
                <template #option="{ option }">
                  {{option.name}}
                  <fts-release-badge alpha class="fts-align-top" v-if="option.isInternal" />
                  <fts-release-badge class="fts-align-top" v-if="option.isBeta" />
                </template>
              </fts-select>
            </fts-form-element>
          </div>

          <template v-if="informationIdVisible">
            <div class="d-widget-design-row-text">of</div>
            <!-- value information -->
            <fts-form-element
              :form-data="formData"
              :item="{
                fieldName: 'informationId',
                displayName: 'Information',
                label: false
              }"
              :validator="$v.formData"
              comfort-design
              class="d-widget-design-row-select"
              key="informationId"
            >
              <fts-select
                slot="formElement"
                slot-scope="{ formData, item, onInput, onBlur, error }"
                v-model="formData[item.fieldName]"
                label="displayName"
                :options="informationIdOptions"
                placeholder="Information"
                :error="!!error"
                comfort-design
                popper-prevent-overflow-alt-axis
                @input="onInput"
                @search:blur="onBlur"
              >
                <fts-label-group
                  slot="selected-option-container"
                  slot-scope="{ option }"
                  :item-id="option.id"
                  :list="informationIdOptions"
                  information
                />
                <fts-label-group
                  slot="option"
                  slot-scope="{ option }"
                  :item-id="option.id"
                  :list="informationIdOptions"
                  information
                />
              </fts-select>
            </fts-form-element>
          </template>
        </div>

        <div class="d-widget-design-row" v-if="Boolean(listingOptions && listingOptions.length) && formData.source != 'listView'">
          <div class="d-widget-design-row-text">In</div>
          <!-- listing -->
          <fts-label-group
            :item-id="formData.listingId"
            :list="listingOptions"
            emoji
            class="comfort-form-design fts-form-group d-widget-design-row-display"
            key="listingIdDisplay"
            v-if="formData.source === 'listView'"
          />
          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'listingId',
              displayName: 'Listing',
              label: false,
            }"
            :validator="$v.formData"
            comfort-design
            key="listingId"
            v-else
          >
            <fts-select
              slot="formElement"
              slot-scope="{ formData, item, onInput, onBlur, error }"
              v-model="formData[item.fieldName]"
              :options="listingOptions"
              placeholder="Listing"
              :error="!!error"
              comfort-design
              popper-prevent-overflow-alt-axis
              @input="onInput"
              @search:blur="onBlur"
            >
              <fts-label-group
                slot="selected-option-container"
                slot-scope="{ option }"
                :item-id="option.id"
                :list="listingOptions"
                emoji
              />
              <fts-label-group
                slot="option"
                slot-scope="{ option }"
                :item-id="option.id"
                :list="listingOptions"
                emoji
              />
            </fts-select>
          </fts-form-element>
        </div>

        <div class="d-widget-design-row">
          <div class="d-widget-design-row-text">By</div>

          <div class="fts-row gutters fts-col-12">
            <div class="fts-col-8">
              <!-- group by information -->
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'groupByInformationId',
                  displayName: 'Group by Information',
                  label: false,
                }"
                :validator="$v.formData"
                comfort-design
                key="groupByInformationId"
              >
                <fts-select
                  slot="formElement"
                  slot-scope="{ formData, item, onInput, onBlur, error }"
                  v-model="formData[item.fieldName]"
                  label="displayName"
                  :options="groupByInformationIdOptions"
                  placeholder="Information"
                  :error="!!error"
                  comfort-design
                  popper-prevent-overflow-alt-axis
                  @input="onInput();updateGroupByInformation()"
                  @search:blur="onBlur"
                >
                  <fts-label-group
                    slot="selected-option-container"
                    slot-scope="{ option }"
                    :item-id="option.id"
                    :list="groupByInformationIdOptions"
                    information
                  />
                  <fts-label-group
                    slot="option"
                    slot-scope="{ option }"
                    :item-id="option.id"
                    :list="groupByInformationIdOptions"
                    information
                  />
                </fts-select>
              </fts-form-element>
            </div>

            <div class="fts-col-4">
              <!-- time interval -->
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'timeInterval',
                  label: false
                }"
                :validator="$v.formData"
                comfort-design
                key="timeInterval"
                v-if="timeIntervalVisible"
              >
                <fts-select
                  slot="formElement"
                  slot-scope="{ formData, item, onInput, onBlur, error }"
                  v-model="formData[item.fieldName]"
                  :options="intervalOptions"
                  placeholder="Interval"
                  :error="!!error"
                  comfort-design
                  popper-prevent-overflow-alt-axis
                  @input="onInput"
                  @search:blur="onBlur"
                />
              </fts-form-element>
              <!-- number interval -->
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'numberInterval',
                  type: 3,
                  label: false
                }"
                :validator="$v.formData"
                comfort-design
                key="numberInterval"
                v-if="numberIntervalVisible"
              />
            </div>
          </div>
        </div>

        <!-- SS05554: sort along the group key, chosen here and saved with the widget so the
             Analyse preview and the dashboard widget read the same way. Empty keeps the
             default order (chronological for a date, the designed sequence for a Select or
             State, largest value first otherwise). -->
        <div class="d-widget-design-row" v-if="sortVisible">
          <div class="d-widget-design-row-text">Sort</div>
          <!-- sort -->
          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'sort',
              displayName: 'Sort',
              label: false,
            }"
            comfort-design
            class="d-widget-design-row-select"
            key="sort"
          >
            <fts-select
              slot="formElement"
              slot-scope="{ formData, item, onInput, onBlur }"
              v-model="formData[item.fieldName]"
              :options="sortOptions"
              placeholder="Default order (optional)"
              comfort-design
              popper-prevent-overflow-alt-axis
              @input="onInput();updateSort();"
              @search:blur="onBlur"
            />
          </fts-form-element>
        </div>

        <div class="d-widget-design-row" v-if="breakdownByInformationIdVisible">
          <div class="d-widget-design-row-text">Breakdown by</div>
          <!-- breakdown by information -->
          <fts-form-element
            :form-data="formData"
            :item="{
              fieldName: 'breakdownByInformationId',
              displayName: 'Breakdown by Information',
              label: false,
            }"
            :validator="$v.formData"
            :validator-error="x => x.format === false ? 'Breakdown by cannot same with By' : null"
            comfort-design
            class="d-widget-design-row-select"
            key="breakdownByInformationId"
          >
            <fts-select
              slot="formElement"
              slot-scope="{ formData, item, onInput, onBlur, error }"
              v-model="formData[item.fieldName]"
              label="displayName"
              :options="breakdownByInformationIdOptions"
              :placeholder="breakdownByInformationIdRequired ? 'Information' : 'Information (optional)'"
              :error="!!error"
              comfort-design
              popper-prevent-overflow-alt-axis
              @input="onInput"
              @search:blur="onBlur"
            >
              <fts-label-group
                slot="selected-option-container"
                slot-scope="{ option }"
                :item-id="option.id"
                :list="breakdownByInformationIdOptions"
                information
              />
              <fts-label-group
                slot="option"
                slot-scope="{ option }"
                :item-id="option.id"
                :list="breakdownByInformationIdOptions"
                information
              />
            </fts-select>
          </fts-form-element>
        </div>
      </template>

      <div class="d-widget-design-row">
        <div class="d-widget-design-row-text">Type</div>
        <!-- type -->
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'type',
            label: false,
          }"
          :validator="$v.formData"
          comfort-design
          key="type"
        >
          <fts-select
            slot="formElement"
            slot-scope="{ formData, item, onInput, onBlur, error }"
            v-model="formData[item.fieldName]"
            :options="chartTypeOptions"
            placeholder="Choosing type according to preference"
            :error="!!error"
            comfort-design
            popper-prevent-overflow-alt-axis
            @input="onInput();updateType();"
            @search:blur="onBlur"
          >
            <template #option="{ option }">
              {{option.name}} <fts-release-badge class="fts-align-top" v-if="option.isBeta" />
            </template>
          </fts-select>
        </fts-form-element>
      </div>

      <fts-collapsible-element
        label="Advanced"
        helper="Exclusive to alpha release."
        variant="style-1"
        comfort-design
        v-if="isInternal && formData.type !== 'content'"
      >
        <template #content>
          <fts-form-element
            :form-data="formData"
            :item="{
              type: 0,
              fieldName: 'name',
              displayName: widgetNameRequired ? 'Chart Name' : 'Chart Name (optional)',
              required: widgetNameRequired
            }"
            :validator="$v.formData"
            comfort-design
            key="chartName"
            v-if="source !== 'listView'"
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge alpha class="fts-align-top" />
            </template>
          </fts-form-element>

          <fts-form-element
            :form-data="formData"
            :item="{fieldName: 'noTotal', input: 'toggleSwitch'}"
            comfort-design
            key="noTotal"
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge alpha class="fts-align-top" />
            </template>
          </fts-form-element>

          <fts-form-element
            :form-data="formData"
            :item="{fieldName: 'limit', input: 'number'}"
            comfort-design
            key="limit"
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge alpha class="fts-align-top" />
            </template>
          </fts-form-element>

          <fts-form-element
            :form-data="rawData"
            :item="{
              fieldName: 'colorCodes', 
              label: 'Colors', 
              type: 0, 
              placeholder: '#2b9ec6, #ef6c00, #a4ce3a, #73cadf'
            }"
            :validator="$v.formData"
            comfort-design
            key="colorCodes"
            @input="updateColorCodes"
          >
            <template #formLabel="{ label }">
              {{label}} <fts-release-badge alpha class="fts-align-top" />
            </template>
          </fts-form-element>
        </template>
      </fts-collapsible-element>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import { required, requiredIf, not, sameAs } from 'vuelidate/lib/validators';

import { authorizationStore } from '../../store/authorizationStore';
import { store as canvasDesignStore } from '../../store/canvasDesignStore';
import { clientStore } from '../../store/clientStore';
import queryLogic from '../../commons/queryLogic';

import FTSCollapsibleElement from '../../elements/FTSCollapsibleElement';
import FTSFormElement from '../../elements/FTSFormElement';
import FTSLabelGroup from '../../elements/FTSLabelGroup';
import FTSSelect from '../../elements/FTSSelect';
import FTSSpinner from '../../elements/FTSSpinner';

export default {
  components: {
    "fts-collapsible-element": FTSCollapsibleElement,
    "fts-form-element": FTSFormElement,
    "fts-label-group": FTSLabelGroup,
    "fts-select": FTSSelect,
    "fts-spinner": FTSSpinner
  },
  props: {
    modules: Array,
    chartData: Object,
    source: String // listView
  },
  data: () => ({
    loading: false,
    preloading: false,
    isProfile: false,
    listingOptions: [],
    logicOptions: [],
    informationOptions: [],
    intervalOptions: [
      // { id: "hour", name: "Hour" },
      { id: "day", name: "Day" },
      /* SS05622: week grouping - the label is the Monday that starts the ISO week
         (resolved server side in LocusService.groupByDate). */
      { id: "week", name: "Week" },
      { id: "month", name: "Month" }
    ],
    /* SS05554: direction along the group key; the server reverses a natural order (time,
       designed option or state sequence) as a whole and compares any other key on its own value */
    sortOptions: [
      { id: "asc", name: "Ascending" },
      { id: "desc", name: "Descending" }
    ],
    rawData: {}
  }),
  validations() {
    let formData = {
      type: { required },
      moduleId: { required },
      aggregate: { required },
      informationId: {
        required: requiredIf(() => this.informationIdVisible)
      },
      timeInterval: {
        required: requiredIf(() => this.timeIntervalVisible)
      },
      numberInterval: {
        required: requiredIf(() => this.numberIntervalVisible)
      },
      aggregate: {
        required: requiredIf(() => !this.formData.logicId)
      },
      groupByInformationId: { 
        required: requiredIf(() => !this.formData.logicId) 
      },
      breakdownByInformationId: {
        required: requiredIf(() => this.breakdownByInformationIdRequired),
        format: not(sameAs("groupByInformationId"))
      },
      colorCodes: {
        format: (value) => {
          if (Array.isArray(value) && value.length)
            return value.every(x => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(x));
          else
            return true;
        }
      },
      name: {
        required: requiredIf(() => this.source !== "listView" && this.widgetNameRequired && this.isInternal)
      }
    };
    return { formData };
  },
  methods: {
    async loadModule() {
      this.listingOptions = [];
      this.logicOptions = [];
      this.informationOptions = [];
      if (this.formData.moduleId) {
        try {
          const res = await canvasDesignStore.dispatch(
            "loadModule",
            this.formData.moduleId
          );
          if (res && res.data) {
            this.listingOptions = res.data.listings;
            this.informationOptions = res.data.information;
            this.logicOptions = res.data.logics;
            this.isProfile = res.data.isUserCollection;
            const findModule = this.modules.find((x) => x.id == res.data.id);
            if (Array.isArray(findModule && findModule.children)) {
              this.listingOptions = this.listingOptions.filter((x) => findModule.children.some((y) => y.id == x.id));
            }
          }
        } catch (err) {
          console.error(err);
          this.$toasted.global.error({ response: err.response });
        }
      }
    },
    updateType() {
      if (!this.breakdownByInformationIdVisible) {
        this.$delete(this.formData, "breakdownByInformationId");
      }
    },
    async updateModuleId() {
      this.$delete(this.formData, "listingId");
      this.$delete(this.formData, "informationId");
      this.$delete(this.formData, "groupByInformationId");
      this.$delete(this.formData, "breakdownByInformationId");
      this.updateGroupByInformation();
      if (this.formData.moduleId) {
        this.preloading = true;
        await this.loadModule();
        this.preloading = false;
      }
    },
    updateAggregate() {
      this.$delete(this.formData, "informationId");
      this.$emit('update:chartData', this.chartData);
    },
    updateGroupByInformation() {
      if (!this.timeIntervalVisible) {
        this.$delete(this.formData, "timeInterval");
      }

      if (!this.numberIntervalVisible) {
        this.$delete(this.formData, "numberInterval");
      }
    },
    updateSort() {
      if (!this.formData.sort) {
        this.$delete(this.formData, "sort");
      }
    },
    updateColorCodes() {
      let colorCodes = null;

      if (this.rawData.colorCodes && this.rawData.colorCodes.trim() && this.rawData.colorCodes.length)
        colorCodes = this.rawData.colorCodes.split(",").map(x => x.trim()).filter(x => x);

      if (colorCodes && colorCodes.length)
        this.$set(this.formData, "colorCodes", colorCodes);
      else
        this.$delete(this.formData, "colorCodes");
    },
    validateForm() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        const information = this.informationOptions.find(x => x.id === this.formData.informationId);

        if (information) {
          if (information.displayName) {
            this.$set(this.formData, "displayName", information.displayName);
          }

          if (information.type !== null && information.type !== undefined) {
            this.$set(this.formData, "informationType", information.type);
          }
        }
      }

      return this.$v.formData;
    }
  },
  computed: {
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    beta() {
      return (
        authorizationStore.getters.isBeta ||
        (this.$route.name === 'builder' || this.$route.name === 'studio' ? canvasDesignStore.getters.workspaceBeta : clientStore.getters.workspaceBeta)
      );
    },
    chartTypeOptions() {
      return [
        { id: "bar", name: "Bar Chart" },
        { id: "stackedBar", name: "Stacked Bar Chart" },
        { id: "barHorizontal", name: "Horizontal Bar Chart" },
        { id: "stackedBarHorizontal", name: "Stacked Horizontal Bar Chart" },
        { id: "line", name: "Line Chart" },
        { id: "pie", name: "Pie Chart" },
        { id: "doughnut", name: "Doughnut Chart" },
        { id: "content", name: "Content", isBeta: true }
      ].filter((x) =>
        !(x.isBeta && !authorizationStore.getters.isBeta) ||
        (this.formData && this.formData.type == x.id)
      );
    },
    aggregateOptions() {
      return [
        { id: "count", name: "Count" },
        { id: "sum", name: "Sum" },
        { id: "max", name: "Maximum", isInternal: true },
        { id: "min", name: "Minimum", isInternal: true },
        // { id: 'average', name: 'Average' },
        { id: "first", name: "First", isBeta: true }
      ].filter((x) =>
        (
          !(x.isInternal && !authorizationStore.getters.isInternal) &&
          !(x.isBeta && !authorizationStore.getters.isBeta)
        ) ||
        (this.formData && this.formData.aggregate == x.id)
      );
    },
    informationIdOptions() {
      if (
        this.formData.aggregate === "max" ||
        this.formData.aggregate === "min"
      ) {
        return this.informationOptions.filter(
          x => [2, 3, 4, 5, 6].indexOf(x.type) > -1
        );
      } else {
        return this.informationOptions.filter(
          x => [2, 3, 4].indexOf(x.type) > -1
        );
      }
    },
    informationIdVisible() {
      return (
        this.formData &&
        this.formData.aggregate &&
        this.formData.aggregate !== "count" &&
        this.formData.aggregate !== "first"
      );
    },
    informationWithSystemOptions() {
      const systemInformation = this.isProfile
        ? [...queryLogic.querySelectionPrefix]
        : [...queryLogic.querySelectionPrefix].filter(x => x.id !== "username");
      return systemInformation.concat(this.informationOptions);
    },
    groupByInformationType() {
      const res = this.informationWithSystemOptions.find(
        x => x.id == this.formData.groupByInformationId
      );
      return res && res.type;
    },
    /* 28 is Tag: an entry holds several of them, and the summary unwinds the array so each
       tag counts once - the same treatment Assign To gets. */
    groupByInformationIdOptions() {
      if (this.formData && this.formData.type === 'content') {
        return this.informationWithSystemOptions;
      }
      return this.informationWithSystemOptions.filter(
        x =>
          x.id !== this.formData.breakdownByInformationId &&
          [0, 1, 5, 6, 7, 16, 19, 20, 25, 26, 27, 28, "state"].indexOf(x.type) > -1
      );
    },
    timeIntervalVisible() {
      return [5, 6].indexOf(this.groupByInformationType) > -1;
    },
    sortVisible() {
      return Boolean(
        this.formData &&
        this.formData.type !== "content" &&
        !this.formData.logicId &&
        this.formData.groupByInformationId
      );
    },
    numberIntervalVisible() {
      return (
        authorizationStore.getters.isDevelopment &&
        [2, 3, 4].indexOf(this.groupByInformationType) > -1
      );
    },
    breakdownByInformationIdOptions() {
      return this.informationWithSystemOptions.filter(
        x =>
          x.id !== this.formData.groupByInformationId &&
          [0, 1, 7, 16, 19, 20, 25, 26, 27, 28, "state"].indexOf(x.type) > -1
      );
    },
    breakdownByInformationIdVisible() {
      return (
        this.formData.type &&
        this.formData.type !== "pie" &&
        this.formData.type !== "doughnut" &&
        this.formData.type !== "content"
      );
    },
    breakdownByInformationIdRequired() {
      return (
        ["stackedBar", "stackedBarHorizontal"].indexOf(this.formData.type) > -1
      );
    },
    widgetNameRequired() {
      if (this.formData && this.formData.filters) {
        return queryLogic.getFiltersValidity(this.formData.filters);
      }

      return false;
    },
    formData: {
      get() {
        return this.chartData;
      },
      set(val) {
        this.$emit('update:chartData', val);
      }
    }
  },
  async mounted() {
    this.loading = true;
    this.formData.widgetType = "chart";
    const valueToKeep = [
      "id",
      "widgetType",
      "name",
      "type",
      "moduleId",
      "aggregate",
      "informationId",
      "listingId",
      "groupByInformationId",
      "timeInterval",
      "numberInterval",
      "breakdownByInformationId",
      "logicId",
      "noTotal",
      "filters",
      "source", // optional ("listView")
      "limit",
      "colorCodes",
      "sort"
    ];

    for (var key in this.formData) {
      if (!valueToKeep.some(x => x == key)) {
        delete this.formData[key];
      }
    }

    if (this.formData.colorCodes && Array.isArray(this.formData.colorCodes)) {
      this.$set(this.rawData, "colorCodes", this.formData.colorCodes.join(", "));
    }

    if (this.formData.moduleId) {
      if (typeof this.formData.moduleId === "number") {
        this.$set(this.formData, "moduleId", this.formData.moduleId.toString());
      }

      await this.loadModule();
    }

    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
@use "./src/components/dashboard/design/scss/style";
</style>